import React from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { Typography } from "@mui/material";

const FRAME_DATA = {
  imgSrc: "/static/img/solutions/fotovoltaico.png",
  imgAlt:
    "Uma casa com painel solar no telhado ao lado de um aplicativo de celular mostrando dados sobre o painel",
  title: "Monitorar meu sistema solar",
  buttonText: "Inserir dados",
};

export const AutomateProsumer = ({ history }) => {
  const handleClick = () => {
    history.push("/onboarding/prosumer-monitoring-credentials");
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleClick}>
      <BlockStandard hideDivider>
        <Typography variant="h2">
          Boa notícia saber que você já está engajado na jornada de
          descarbonização energética!
        </Typography>
        <Typography>
          Estamos aqui para te apoiar simplificando e acelerando essa jornada
          com você!
        </Typography>
        <Typography>
          Para podermos mostrar seus dados de geração de energia solar, economia
          e descarbonização obtida precisamos dos dados de acesso à plataforma
          de monitoramento do inversor do seu sistema solar e dos dados de
          acesso ao site da sua concessionária de energia.
        </Typography>
      </BlockStandard>
    </SolutionsFrame>
  );
};
